import type { ThemePreference } from "../api/types.js";
import "./theme-swatches.css";

const THEMES: ReadonlyArray<{ id: ThemePreference; label: string }> = [
  { id: "vantablack", label: "Vantablack" },
  { id: "light", label: "Light" },
  { id: "system", label: "System" },
];

export function ThemeSwatches({
  preference,
  onChange,
}: {
  preference: ThemePreference;
  onChange: (preference: ThemePreference) => void;
}) {
  return (
    <fieldset className="theme-swatches" data-testid="theme-swatches">
      <legend className="sr-only">Theme</legend>
      {THEMES.map((theme) => {
        const selected = preference === theme.id;
        return (
          <button
            className={`theme-swatch theme-swatch--${theme.id}${selected ? " theme-swatch--selected" : ""}`}
            type="button"
            key={theme.id}
            aria-pressed={selected}
            onClick={() => onChange(theme.id)}
          >
            <span className="theme-swatch__chip" aria-hidden="true" />
            <span>{theme.label}</span>
          </button>
        );
      })}
    </fieldset>
  );
}
